/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { useWindowResize } from "utils/hooks";
import { getPopularAndRecentTerms } from "utils/apiClients";
import { isUserLoggedIn } from "utils";
import { ToastContext } from "context/Toast/ToastContext";
import { ApplyButton } from "components/JobListingPageComponents/FiltersSidebar/styles";
import {
	generateSearchSessionID,
	getPrefilledLocation,
	getSearchEventProps,
	setSearchEventProps,
} from "utils/commonUtils";
import { SEARCH_MP_EVENTS_PROPS_NAME } from "modules/candidate/profile/constants/mixpanelConstants";
import OutlinedSearch from "assets/svgs/OutlinedSearch";
import OutlinedLocationIcon from "assets/svgs/OutlinedLocationIcon";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import clsx from "clsx";
import SuitcaseSearchIcon from "assets/svgs/SuitcaseSearchIcon";
import ChevronDownIcon from "assets/svgs/ChevronDownIcon";
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";
import { Popper } from "@material-ui/core";
import {
	MIN_EXPERIENCE_DEFAULT_VALUE,
	VALUE_TO_LABEL_MAPPING,
} from "components/RevampFeedDetails/constants";
import { Correction } from "types/job/jobCorrectionType";
import SearchInput from "./SearchInput";
import QuerySearchResults from "./QuerySearchResults";
import CitySearchResults from "./CitySearchResults";
import ExperienceSearchResults from "./ExperienceSearchResults";

const SEARCH_OPTIONS = ["title", "company", "skill"];

export const getFinalUrl = (
	query,
	location,
	queryString,
	experience,
	correction?: Correction,
	searchId?: string
) => {
	let queryParams = "";

	if (!location?.id && (location?.location?.id > 0 || location?.location?.identifier)) {
		queryParams += "?";
		const locationProperties = Object.entries(location?.location);
		locationProperties.forEach((property, index) => {
			queryParams += `location_${property[0]}=${property[1]}${
				index <= property?.length ? "&" : ""
			}`;
		});
	}
	if (location?.identifier || location?.id) {
		queryParams += "?";
		const locationProperties = Object.entries(location);
		locationProperties.forEach((property, index) => {
			queryParams += `location_${property[0]}=${property[1]}${
				index <= property?.length ? "&" : ""
			}`;
		});
	}

	if (
		location?.id > 0 &&
		!location?.location?.id &&
		!location?.location?.identifier &&
		!location?.identifier
	) {
		queryParams += `?city_id=${location.id}`;
	}

	if (queryString) {
		let tempString = `search=true&text=${encodeURIComponent(queryString)}`;
		if (query?.id) {
			tempString += `&entity_id=${query?.id}`;
		}
		if (query?.type) {
			tempString += `&entity_type=${query?.type}`;
		}
		if (query?.entity_id) {
			tempString += `&entity_id=${query?.entity_id}`;
		}
		if (query?.entity_type) {
			tempString += `&entity_type=${query?.entity_type}`;
			// if (query.type === "Department" && query?.id) {
			// 	tempString += `&department_id=${query?.id}`;
			// }
			if (query.type === "Company" && query?.id) {
				tempString += `&company_id=${query?.id}`;
			}
		}
		queryParams = queryParams.length
			? `${queryParams}&${tempString}`
			: `?${tempString}`;
	}
	if (
		experience?.experience_input &&
		experience?.experience_input !== MIN_EXPERIENCE_DEFAULT_VALUE
	) {
		queryParams += `&min_experience=${experience?.experience_input}`;
	}

	if (correction && Object.keys(correction).length > 0) {
		queryParams += "&raw_text_correction=false";
	} else {
		queryParams += "&raw_text_correction=true";
	}

	if (searchId) {
		queryParams += `&session_id=${searchId}`;
	}

	return isUserLoggedIn()
		? isUserLoggedIn()
			? `/candidate/jobs${queryParams}${
					queryParams.length ? "&" : "?"
			  }c_id=${isUserLoggedIn()}`
			: `/candidate/jobs${queryParams}&&c_id=${isUserLoggedIn()}`
		: `/jobs${queryParams}`;
};

function SearchComponent({
	fromHomePage = false,
	appliedFilterCount = null,
	handleMobileClose = () => null,
}) {
	const {
		resetFilters,
		citySearchObject,
		titleSearchObject,
		experienceSearchObject,
		isDesktopSearchExpanded,
		defaultLocationCleared,
		jobFeedSearchInputPrefillData,
		setDefaultLocationCleared,
		setTitleSearchObject,
		setCitySearchObject,
		setExperienceSearchObject,
		setManualUserSearchInputs,
		addExperienceInFilters,
		setSearchSessionId,
	} = useJobFeedStore();
	const router = useRouter();

	const { experienceObj, locationObj } = router.query;

	const [queryString, setQueryString] = useState(
		titleSearchObject?.display_name ||
			(typeof titleSearchObject === "string" && titleSearchObject) ||
			""
	);
	const [experienceString, setExperienceString] = useState(
		experienceSearchObject?.display_text || ""
	);
	const [cityString, setCityString] = useState(
		citySearchObject?.name ||
			citySearchObject?.display_text_with_location ||
			citySearchObject?.location?.name ||
			""
	);
	const [queryError, setQueryError] = useState(false);

	const [popularSearches, setPopularSearches] = useState([]);
	const [recentSearches, setRecentSearches] = useState([]);

	const [selectedSearchInputOption, setSelectedSearchInputOption] = useState("");
	const [selectedSearchResults, setSelectedSearchResults] = useState(null);
	const [searchFeatureUsed, setSearchFeatureUsed] = useState("");

	const queryRef = useRef();
	const experienceRef = useRef();
	const cityRef = useRef();
	const searchBoxRef = useRef();
	const applyButtonRef = useRef(null);
	const { handleOpenToast } = useContext(ToastContext);

	const [isMobileView] = useWindowResize();

	const handleSearchFeatureUsed = (value) => {
		setSearchFeatureUsed(value);
	};

	useEffect(() => {
		if (locationObj === "empty") {
			setCitySearchObject({});
		}
		if (experienceObj === "empty") {
			setExperienceSearchObject({});
		}
	}, [locationObj, experienceObj, router.query]);

	/* 
		For a logged in user, we want to prefill the default location and experience.
		Once user clears default location, we should not pre-fill it again on route changes
		or if component unmounts and remounts. 
		defaultLocationCleared is a flag set in the global store. If user clears location input,
		we set it to true.
		We also don't want to pre-fill default location if another location is already selected.
		This useEffect handles prefilling for jobFeed.
	*/
	useEffect(() => {
		if (
			!defaultLocationCleared &&
			!(
				citySearchObject?.display_text ||
				citySearchObject?.location?.name ||
				citySearchObject?.name
			) &&
			jobFeedSearchInputPrefillData?.location?.name
		) {
			setCityString(jobFeedSearchInputPrefillData?.location?.name);
			setCitySearchObject({
				location: jobFeedSearchInputPrefillData?.location,
				display_text: jobFeedSearchInputPrefillData?.location?.name,
			});
		}
		if (
			jobFeedSearchInputPrefillData?.min_experience &&
			!experienceSearchObject?.display_text
		) {
			setExperienceSearchObject({
				display_text:
					VALUE_TO_LABEL_MAPPING?.min_experience?.[
						jobFeedSearchInputPrefillData.min_experience
					],
				experience_input: jobFeedSearchInputPrefillData.min_experience,
			});
		}
	}, [defaultLocationCleared, jobFeedSearchInputPrefillData]);

	useEffect(() => {
		setCityString(
			citySearchObject?.display_text_with_location ||
				citySearchObject?.display_text ||
				citySearchObject?.location?.name ||
				citySearchObject?.name
		);
	}, [citySearchObject]);

	useEffect(() => {
		if (selectedSearchInputOption === "query") {
			setSelectedSearchResults(
				<QuerySearchResults
					handleQuerySelect={handleQuerySelect}
					handleExperienceSelect={handleExperienceSelect}
					handleCitySelect={handleCitySelect}
					query={queryString}
					popularSearches={popularSearches}
					recentSearches={recentSearches}
					handleSearchFeatureUsed={handleSearchFeatureUsed}
				/>
			);
		}
		if (selectedSearchInputOption === "experience") {
			setSelectedSearchResults(
				<ExperienceSearchResults
					handleExperienceSelect={handleExperienceSelect}
					handleSearchFeatureUsed={handleSearchFeatureUsed}
				/>
			);
		}
		if (selectedSearchInputOption === "city") {
			setSelectedSearchResults(
				<CitySearchResults
					handleCitySelect={handleCitySelect}
					query={cityString}
				/>
			);
		}
	}, [selectedSearchInputOption, experienceString, queryString, cityString]);

	useEffect(() => {
		setQueryString(
			titleSearchObject?.display_name ||
				(typeof titleSearchObject === "string" && titleSearchObject) ||
				""
		);
	}, [titleSearchObject]);
	useEffect(() => {
		setExperienceString(experienceSearchObject?.display_text || "");
	}, [experienceSearchObject]);

	useEffect(() => {
		if (isUserLoggedIn()) {
			getPopularAndRecentTerms().then(
				(res) => {
					setPopularSearches(res?.data?.popular_terms_response?.terms || []);
					setRecentSearches(res?.data?.recent_terms_response?.terms || []);
				},
				(error) => {
					console.log("error", error);
					setPopularSearches([]);
					setRecentSearches([]);
				}
			);
		}
	}, []);

	function handleQuerySelect(queryObject) {
		setQueryError(false);
		setTitleSearchObject(queryObject);
		setQueryString(queryObject?.display_name);
		setManualUserSearchInputs({
			keyword: queryObject?.display_name,
		});
		(queryRef?.current as any)?.blur();
		setSelectedSearchResults(null);
		setSelectedSearchInputOption("");
	}
	const handleExperienceSelect = (val) => {
		setExperienceString(val.display_text);
		setExperienceSearchObject(val);
		setManualUserSearchInputs({
			experience: val,
		});
		(experienceRef?.current as any)?.blur();
		setSelectedSearchResults(null);
		setSelectedSearchInputOption("");
	};

	const handleCitySelect = (cityObject) => {
		if (!cityObject) return;
		setCitySearchObject(cityObject);
		setCityString(
			cityObject?.display_text_with_location ||
				cityObject?.location?.name ||
				cityObject?.name
		);
		setManualUserSearchInputs({
			location:
				cityObject?.display_text_with_location ||
				cityObject?.location?.name ||
				cityObject?.name,
		});
		(cityRef?.current as any)?.blur();
		setSelectedSearchResults(null);
		setSelectedSearchInputOption("");
	};

	const trackMixpanelEvent = (cityStr, queryStr, isSearch, city) => {
		trackOnMixpanel("Search Jobs Button Clicked", {
			Job_Search_Ingress: fromHomePage
				? "Home Page"
				: isSearch || appliedFilterCount
				? "Fetched Results"
				: "Job Listing Page",
			query: queryStr?.length > 0 ? queryStr : null,
			city: cityStr?.length > 0 ? cityStr : null,
			experience: experienceString || "N/A",
			isQueryError: !queryStr ? true : null,
			isCityError:
				(!city || city.display_text !== cityStr) &&
				cityStr !== "Anywhere in India"
					? true
					: null,
		});
	};

	const handleSubmit = (query, city, experience) => {
		if (!queryString || queryString.trim().length === 0) {
			setQueryError(true);
			setQueryString("");
			if (isMobileView) {
				handleOpenToast({
					heading: "Please enter a job title, company, skill or department",
					type: "error",
				});
			}
			return;
		}
		setQueryError(false);
		resetFilters();
		if (isMobileView) {
			if (experience.experience_input) {
				addExperienceInFilters(experience?.experience_input);
			}
			handleMobileClose();
		}
		const isSearch = router?.query?.search;
		const searchEventObj = getSearchEventProps();
		const prefilledLocation = getPrefilledLocation();
		const searchSessionId = generateSearchSessionID();
		setSearchSessionId(searchSessionId);

		trackMixpanelEvent(cityString, queryString, isSearch, city);
		const searchFeatureUsedVal = searchFeatureUsed
			? searchFeatureUsed || "Fuzzy"
			: undefined;

		const obj = {
			[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_SOURCE]: fromHomePage
				? "Home Page"
				: isSearch || appliedFilterCount
				? "Fetched Results"
				: "Job Listing Page",
			[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]: searchFeatureUsedVal,
		};
		if (!queryString) {
			obj[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED] = null;
		}
		if (prefilledLocation === cityString) {
			obj[SEARCH_MP_EVENTS_PROPS_NAME.LOCATION_SEARCH_FEATURE_USED] = "Default";
		}
		const resObj = { ...searchEventObj, ...obj };
		setSearchEventProps(resObj);
		// In case of fuzzy search
		if (
			queryString !== titleSearchObject?.display_name &&
			queryString !== titleSearchObject?.name
		) {
			setTitleSearchObject(queryString);
			const url = getFinalUrl(
				{},
				city,
				queryString,
				experience,
				undefined, // correction excluded
				searchSessionId
			);
			router?.push(url);
			return;
		}

		const url = getFinalUrl(
			query,
			city,
			queryString,
			experience,
			undefined, // correction excluded
			searchSessionId
		);
		if (url) {
			setQueryError(false);
			router?.push(url);
		}
	};

	return (
		<>
			<div
				ref={searchBoxRef}
				className={clsx(
					"mb-[36px] mt-auto flex w-full flex-col items-center gap-[16px] rounded-xl bg-white pb-[16px] md:mb-0 md:flex-row md:gap-0 md:p-[12px]",
					{
						"inline-flex md:w-[860px]": fromHomePage,
					}
				)}
				style={{
					// boxShadow: "0px 16px 32px 0px #0000000A",
					background: fromHomePage ? "white" : "#F4F2F6",
					border: !isMobileView && queryError ? "1px solid #CB2F67" : "none",
				}}
				data-testid="search-component-desktop"
			>
				<div
					className="inline-flex w-full flex-col gap-[8px] px-[12px] pb-[16px] pt-[16px] md:flex-row md:px-0 md:pb-0 md:pt-0"
					style={{
						boxShadow: isMobileView
							? "0px 2px 12px 0px rgba(0, 0, 0, 0.08)"
							: "none",
					}}
				>
					<SearchInput
						isUserLoggedIn={!!isUserLoggedIn()}
						isQuery
						fromHomePage={fromHomePage}
						appliedFilterCount={appliedFilterCount}
						fullWidth
						ref={queryRef}
						recentSearches={recentSearches}
						value={queryString}
						setValue={(val) => {
							setQueryString(val);
							// For fuzzy search
							setManualUserSearchInputs({
								keyword: val,
							});
						}}
						selectInputOnFocus={() => {
							setSelectedSearchInputOption("query");
							setSelectedSearchResults(
								<QuerySearchResults
									handleQuerySelect={handleQuerySelect}
									handleExperienceSelect={handleExperienceSelect}
									handleCitySelect={handleCitySelect}
									query={queryString}
									popularSearches={popularSearches}
									recentSearches={recentSearches}
									handleSearchFeatureUsed={handleSearchFeatureUsed}
								/>
							);
						}}
						icon={<OutlinedSearch height="16" width="16" />}
						closeIcon={<CrossIcon fill="#827485" />}
						placeholders={SEARCH_OPTIONS.map(
							(option) => `Search jobs by '${option}'`
						)}
						showRightBorder
						searchBoxRef={searchBoxRef}
						mixPanelEventType="Query"
						showSearchList={
							(!!isUserLoggedIn() &&
								(popularSearches.length > 0 ||
									recentSearches.length > 0)) ||
							!!queryString
						}
						handleClear={() => {
							setQueryString("");
							setTitleSearchObject({});
						}}
						testId="search-keyword-input"
					>
						{/* For Desktop shown as popper */}
						<QuerySearchResults
							handleQuerySelect={handleQuerySelect}
							handleExperienceSelect={handleExperienceSelect}
							handleCitySelect={handleCitySelect}
							query={queryString}
							recentSearches={recentSearches}
							handleSearchFeatureUsed={handleSearchFeatureUsed}
						/>
					</SearchInput>
					<div
						tabIndex={0}
						onBlur={() => {
							setSelectedSearchInputOption("expeience");
							setSelectedSearchResults(null);
						}}
						className={clsx(
							"flex w-full cursor-pointer items-center space-x-[8px] rounded-[8px] border border-solid bg-[#F4F2F6] px-[8px] py-[12px] outline-none md:m-0 md:border-none md:p-0 md:px-[4px]",
							{
								"md:bg-white": !isDesktopSearchExpanded,
								"bg-[#F4F2F6]": !isMobileView && isDesktopSearchExpanded,
							}
						)}
						onClick={() => {
							trackOnMixpanel("Search Bar Clicked Web", {
								Job_Search_Ingress: fromHomePage
									? "Home Page"
									: router?.query?.search || appliedFilterCount
									? "Fetched Results"
									: "Job Listing Page",
								Section: "Experience",
							});
							setSelectedSearchInputOption("experience");
							setSelectedSearchResults(
								<ExperienceSearchResults
									handleExperienceSelect={handleExperienceSelect}
									handleSearchFeatureUsed={handleSearchFeatureUsed}
								/>
							);
						}}
						ref={experienceRef}
						data-testid="search-experience-input"
					>
						<SuitcaseSearchIcon size="16" />
						<p
							className={clsx(
								"m-0 flex-1 text-nowrap leading-[24px] text-[#190A28]",
								{
									"text-[16px] text-[#8C8594]": !experienceString,
								}
							)}
						>
							{experienceString || "Your Experience"}
						</p>
						{!experienceString && (
							<div className="px-[8px]">
								<ChevronDownIcon fill="#827485" />
							</div>
						)}
						{experienceString && (
							<div
								className="px-[8px]"
								onClick={() => {
									setExperienceSearchObject({});
									setExperienceString("");
									setManualUserSearchInputs({
										experience: null,
									});
								}}
							>
								<CrossIcon fill="#827485" />
							</div>
						)}
						<div className="hidden h-full w-[1px] bg-[#D1CED4] md:block" />

						{!isMobileView && (
							<Popper
								anchorEl={experienceRef.current}
								open={selectedSearchInputOption === "experience"}
								modifiers={{
									offset: {
										enabled: true,
										offset: "0,30",
									},
								}}
								className="z-[1000] max-h-[200px] w-[420px] max-w-[400px] overflow-y-auto !rounded-[8px] bg-white shadow-200 md:w-[200px]"
								placement="bottom-start"
							>
								<div className="flex w-[100vw] flex-col gap-3 bg-white py-[16px] md:w-full md:rounded-[8px]">
									<ExperienceSearchResults
										handleExperienceSelect={handleExperienceSelect}
										handleSearchFeatureUsed={handleSearchFeatureUsed}
									/>
								</div>
							</Popper>
						)}
					</div>

					<SearchInput
						appliedFilterCount={appliedFilterCount}
						fullWidth
						ref={cityRef}
						value={cityString}
						setValue={(val) => {
							setCityString(val);
						}}
						handleClear={() => {
							setCityString("");
							setCitySearchObject({});
							setDefaultLocationCleared(true);
							setManualUserSearchInputs({
								location: null,
							});
						}}
						selectInputOnFocus={() => {
							setSelectedSearchInputOption("city");
							setSelectedSearchResults(
								<CitySearchResults
									handleCitySelect={handleCitySelect}
									query={cityString}
								/>
							);
						}}
						icon={<OutlinedLocationIcon width="16" height="16" />}
						closeIcon={<CrossIcon fill="#827485" />}
						placeholders={["Search for an area or city"]}
						searchBoxRef={searchBoxRef}
						fromHomePage={fromHomePage}
						mixPanelEventType="Location"
						handleChange={(val) => {
							handleCitySelect(val);
						}}
						showSearchList={selectedSearchInputOption === "city"}
						testId="search-location-input"
					>
						<CitySearchResults
							handleCitySelect={handleCitySelect}
							query={cityString}
						/>
					</SearchInput>

					<ApplyButton
						onClick={() =>
							handleSubmit(
								titleSearchObject,
								citySearchObject,
								experienceSearchObject
							)
						}
						variant="primary"
						ref={applyButtonRef}
						data-testid="search-button"
					>
						Search&nbsp;jobs
					</ApplyButton>
				</div>
				{/* For mobile search input results */}
				{isMobileView && selectedSearchResults}
			</div>
			{!isMobileView && queryError && (
				<div className="flex flex-row items-center gap-2 text-[14px] font-normal text-[#CB2F67]">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
					>
						<path
							d="M9.99935 1.66699C5.39935 1.66699 1.66602 5.40033 1.66602 10.0003C1.66602 14.6003 5.39935 18.3337 9.99935 18.3337C14.5993 18.3337 18.3327 14.6003 18.3327 10.0003C18.3327 5.40033 14.5993 1.66699 9.99935 1.66699ZM9.99935 14.167C9.54102 14.167 9.16602 13.792 9.16602 13.3337V10.0003C9.16602 9.54199 9.54102 9.16699 9.99935 9.16699C10.4577 9.16699 10.8327 9.54199 10.8327 10.0003V13.3337C10.8327 13.792 10.4577 14.167 9.99935 14.167ZM10.8327 7.50033H9.16602V5.83366H10.8327V7.50033Z"
							fill="#CB2F67"
						/>
					</svg>
					<span>Please enter a job title, company, skill or department</span>
				</div>
			)}
		</>
	);
}

export default SearchComponent;
